module.exports = __webpack_public_path__ + "static/media/header-testimonial-background.7ef04b0c.jpg";